module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('ui-textbox', {
    attrs: {
      "label": "Nazwa",
      "name": "name",
      "type": "text",
      "autofocus": _vm.autofocus,
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.item.name = $$v
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "template_type",
      "label": "Typ szablonu",
      "options": _vm.templateTypes,
      "placeholder": "Wybierz typ szablonu",
      "required": ""
    },
    model: {
      value: (_vm.item.template_type),
      callback: function($$v) {
        _vm.item.template_type = $$v
      },
      expression: "item.template_type"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Treść szablonu",
      "name": "body",
      "type": "text",
      "rows": 10,
      "multi-line": true
    },
    model: {
      value: (_vm.item.body),
      callback: function($$v) {
        _vm.item.body = $$v
      },
      expression: "item.body"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fa92556","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/Form.vue
// module id = 264
// module chunks = 0